<div class="imprint">
  <div class="imprint-container">
    <h1>{{ "IMPRINT.TITLE" | translate }}</h1>
    <p>
      Jonas Valtin<br />
      <!-- Hauptstraße 40 b<br />
      08606 Schönbrunn -->
    </p>
  </div>

  <div class="imprint-container">
    <h2>{{ "IMPRINT.CONTACT" | translate }}</h2>
    <p>
      {{ "IMPRINT.PHONE" | translate }}: +49 (0) 15204845678<br />
      {{ "IMPRINT.EMAIL" | translate }}: j.valtin&#64;online.de
    </p>
  </div>

  <div class="imprint-container">
    <h2>{{ "IMPRINT.RESPONSIBLE" | translate }}</h2>
    <p>
      Jonas Valtin<br />
      <!-- Hauptstraße 40b<br />
      08606 Schönbrunn -->
    </p>
  </div>

  <p>
    {{ "IMPRINT.SOURCE" | translate }} :
    <a href="https://www.e-recht24.de">e-recht24.de</a>
  </p>
</div>
